export default function Check_ins() {
    return <h1>Check-ins</h1>;
  }